// "Mark as task" in a chat without a project (1:1 chats, Teams chats not filed under one): every
// task belongs to a project, so the user picks it first. Same sheet as the project field of
// TaskCreatePanel; picking a project creates the bookmark there, closing it creates nothing.
//
//   <BookmarkProjectSheet open onPick={(room) => …} onClose={() => …} />
import React, { useEffect, useMemo, useState } from "react";
import { SelectSheet, useTodoText } from "../../pages/Feeds/ToDoProParts";
import { loadAllRooms } from "../../pages/Cockpit/components/CockpitTodoLists";
import { fill } from "../../pages/Feeds/todoProModel";
import "../../pages/Feeds/ToDoPro.css";

export default function BookmarkProjectSheet({ open, onPick, onClose }) {
  const { t } = useTodoText();
  // External and internal (Kjuup+) projects, as the cockpit's project picker lists them.
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!open) return undefined;
    let alive = true;
    setLoading(true);
    loadAllRooms()
      .then((list) => {
        if (alive) setRooms([...(list || [])].sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""))));
      })
      .catch(() => {})
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [open]);
  const items = useMemo(
    () => rooms.map((room) => ({ key: room.id, title: room.name, avatar: { name: room.name, kind: "room" } })),
    [rooms]
  );

  const pick = (key) => {
    const room = rooms.find((r) => String(r.id) === String(key));
    if (room && onPick) onPick({ id: room.id, name: room.name || "" });
  };

  return (
    <SelectSheet
      open={!!open}
      title={t("pro_todo_choose_project", "Which project is this task for?", "Für welches Projekt ist die Aufgabe?")}
      items={items}
      value={null}
      onChange={pick}
      onClose={onClose}
      loading={loading}
      searchPlaceholder={t("pro_todo_search_rooms", "Search projects", "Projekte durchsuchen")}
      emptyText={(q) =>
        q
          ? fill(t("pro_todo_no_rooms_match", "No projects match “{{q}}”", "Keine Projekte für „{{q}}“"), { q })
          : t("pro_todo_no_rooms", "No projects found", "Keine Projekte gefunden")
      }
      closeLabel={t("close", "Close", "Schließen")}
      clearLabel={t("pro_todo_clear", "Clear", "Zurücksetzen")}
    />
  );
}
